import { useState } from 'react';
import { FaRegPaperPlane } from 'react-icons/fa';
import { toast } from 'react-toastify';
import animationContact from '../../../../Images/01.jpg';
import './ContactFrom.css';

const ContactFrom = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    details: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        'https://msolaimantechnical.com/master/api/v1/message/store',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            subject: formData.subject,
            details: formData.details,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        toast.success('Message sent Successfully', {
          autoClose: 2000,
        });
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          details: '',
        });
      } else {
        toast.error('Something went wrong', {
          autoClose: 3000,
        });
      }
    } catch (error) {
      toast.error('Server Error', {
        autoClose: 3000,
      });
    }
  };

  return (
    <section className='bg-white contact-from'>
      <div className='container p-6 mx-auto'>
        <div className='grid grid-cols-1 lg:grid-cols-12 items-center gap-10'>
          {/* Image Section (col-lg-5) */}
          <div className='lg:col-span-5'>
            <img
              src={animationContact}
              alt='images'
              className='w-full h-auto rounded-[40px]'
            />
          </div>

          {/* Form Section (col-lg-7) */}
          <div className='mt-8 lg:mt-0 lg:col-span-7'>
            <div className='form-card'>
              <div>
                <h4 className='capitalize text-[18px] sm:text-[20px] md:text-[23px] lg:text-[26px] xl:text-[30px] font-semibold leading-tight mb-3'>
                  Get In Touch
                </h4>
                <p className='text-[15px] text-[#6C706F] mb-7'>
                  Our team is committed to providing exceptional customer
                  service and is ready to assist you with any questions or
                  concerns. Fill out this form and let’s chat about how we can
                  help you reach your goals.
                </p>
              </div>
              <form
                onSubmit={handleSubmit}
                className='container flex flex-col mx-auto space-y-12'
              >
                <fieldset className='grid grid-cols-6 gap-6'>
                  <div className='grid grid-cols-6 gap-4 col-span-full'>
                    <div className='col-span-full sm:col-span-3'>
                      <input
                        type='text'
                        name='name'
                        placeholder='Your Name'
                        value={formData.name}
                        onChange={handleChange}
                        className='w-full p-3 rounded-md bg-white text-black input-from-contorl'
                        required
                      />
                    </div>

                    <div className='col-span-full sm:col-span-3'>
                      <input
                        type='email'
                        name='email'
                        value={formData.email}
                        onChange={handleChange}
                        placeholder='Your Email'
                        className='w-full p-3 rounded-md text-gray-900 input-from-contorl'
                        required
                      />
                    </div>

                    <div className='col-span-full'>
                      <input
                        type='text'
                        name='phone'
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder='Your Number'
                        className='w-full p-3 rounded-md text-gray-900 input-from-contorl'
                        required
                      />
                    </div>

                    <div className='col-span-full'>
                      <input
                        type='text'
                        name='subject'
                        value={formData.subject}
                        onChange={handleChange}
                        placeholder='Your Subject'
                        className='w-full p-3 rounded-md text-gray-900 input-from-contorl'
                        required
                      />
                    </div>

                    <div className='col-span-full'>
                      <textarea
                        rows='5'
                        name='details'
                        placeholder='Write Your Message'
                        className='w-full p-3 rounded-md text-gray-900 input-from-contorl'
                        value={formData.details}
                        onChange={handleChange}
                        required
                      ></textarea>
                    </div>

                    <div className='col-span-full'>
                      <button type='submit' className='primary-btn'>
                        Send Message
                        <FaRegPaperPlane className='ml-2' />
                      </button>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactFrom;
